<img [ngSrc]="flagPath" [alt]="language" width="24" height="24" />
